import { DELETE, GET, POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/products/${endpoint}`;
};

export const getVoucherThemes = (token, clientRef, page, limit) => {
  let endpoint = `all-products?featured=true&page=${page}&limit=${limit}`;
  if (clientRef) {
    endpoint += `&clientRef=${clientRef}`;
  }

  endpoint = getEndpointWithPrefix(endpoint);
  return GET(endpoint, token);
};

export const updateVoucherTheme = async (themeData, token, themeId) => {
  const endpoint = getEndpointWithPrefix(`update-product/${themeId}`);
  // POST signature: (endpoint, requestBody = {}, authorization = null)
  return POST(endpoint, themeData, token);
};
export const getAllProducts = (
  token,
  featured = undefined,
  published = undefined,
  page = 0,
  limit = 25,
  clientRef = false,
) => {
  // Build query params dynamically only when values are provided
  const params = [];
  if (featured !== undefined && featured !== null) params.push(`featured=${featured}`);
  if (published !== undefined && published !== null) params.push(`published=${published}`);
  if (clientRef !== undefined && clientRef !== false) params.push(`clientRef=${encodeURIComponent(clientRef)}`);
  params.push(`page=${page}`);
  params.push(`limit=${limit}`);

  const query = params.length ? `?${params.join('&')}` : '';
  const endpoint = `/products/all-products${query}`;
  return GET(endpoint, token);
};

export const addProduct = (productData, token) => {
  const endpoint = getEndpointWithPrefix('create');
  return POST(endpoint, productData, token);
}

export const getProductCategories = (token) => {
  const endpoint = getEndpointWithPrefix('product-category');
  return GET(endpoint, token);
};

export const updateProduct = (token, productId, productData) => {
  const endpoint = getEndpointWithPrefix(`update/${productId}`);
  return PUT(endpoint, productData, token);
};

export const deleteProduct = (token, productId) => {
  const endpoint = getEndpointWithPrefix(`delete/${productId}`);
  return DELETE(endpoint, {}, token);
};